// src/components/Dashboard/AdminDashboard.js
import React, { useState } from 'react';
import AdminHome from './AdminHome';
import AdminPartner from './AdminPartner';
import AdminMember from './AdminMember';
import AdminApproved from './AdminApproved';
import RoleManager from '../Admin/RoleManager';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('home');

  const renderTabContent = () => {
    switch(activeTab) {
      case 'home': return <AdminHome />;
      case 'partner': return <AdminPartner />;
      case 'member': return <AdminMember />;
      case 'approved': return <AdminApproved />;
      case 'role_manager': return <RoleManager />;
      default: return <AdminHome />;
    }
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-tabs">
        <button 
          className={activeTab === 'home' ? 'active' : ''}
          onClick={() => setActiveTab('home')}
        >
          Home
        </button>
        <button 
          className={activeTab === 'partner' ? 'active' : ''}
          onClick={() => setActiveTab('partner')}
        >
          Partner Applications
        </button>
        <button 
          className={activeTab === 'member' ? 'active' : ''}
          onClick={() => setActiveTab('member')}
        >
          Member Applications
        </button>
        <button 
          className={activeTab === 'approved' ? 'active' : ''}
          onClick={() => setActiveTab('approved')}
        >
          Approved Applications
        </button>
        <button 
          className={activeTab === 'role_manager' ? 'active' : ''}
          onClick={() => setActiveTab('role_manager')}
        >
          Role Manager
        </button>
      </div>

      <div className="admin-tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default AdminDashboard;